// Portions of this code are adapted from the MUI Toolbar component.
// Source: https://github.com/mui/toolpad/blob/master/packages/toolpad-core/src/DashboardLayout/DashboardLayout.tsx
// MUI is licensed under the MIT License: https://github.com/mui/toolpad/blob/master/LICENSE

import { Navigation } from '../../types';
import { getDrawerSxTransitionMixin } from '../utils';
import { useSidebarContext } from '../context/SidebarContext';
import { SidebarNavigation } from './SidebarNavigation';
import Box from '@mui/material/Box';
import { useCallback } from 'react';

interface SidebarContentProps {
    navigation: Navigation;
    isMini?: boolean;
    hasDrawerTransitions?: boolean;
    sidebarExpandedWidth: number | string;
}

export function SidebarContent({
    navigation,
    isMini = false,
    hasDrawerTransitions = false,
    sidebarExpandedWidth,
}: SidebarContentProps) {
    const {
        setIsMobileNavigationExpanded,
        isNavigationFullyExpanded,
        isNavigationFullyCollapsed,
    } = useSidebarContext();

    const handleNavigationLinkClick = useCallback(() => {
        setIsMobileNavigationExpanded(false);
    }, [setIsMobileNavigationExpanded]);

    return (
        <Box
            component="nav"
            sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                overflow: 'auto',
                scrollbarGutter: isMini ? 'stable' : 'auto',
                overflowX: 'hidden',
                pt: navigation[0]?.kind === 'header' && !isMini ? 0 : 2,
                ...(hasDrawerTransitions ? getDrawerSxTransitionMixin(isNavigationFullyExpanded, 'padding') : {}),
            }}
        >
            <SidebarNavigation
                navigation={navigation}
                isMini={isMini}
                isFullyExpanded={isNavigationFullyExpanded}
                isFullyCollapsed={isNavigationFullyCollapsed}
                hasDrawerTransitions={hasDrawerTransitions}
                sidebarExpandedWidth={sidebarExpandedWidth}
                onLinkClick={handleNavigationLinkClick}
            />
        </Box>
    );
}
